var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E8F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12262_73053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7 14.0875L24.2 8.5375C24.1 8.4875 24 8.4875 23.85 8.5375L8.35 14.0875C8.15 14.1875 8 14.3375 8 14.5875C8 14.7875 8.15 14.9875 8.3 15.0375L14.65 17.2875V17.7875C14.65 21.1875 16.5 24.3875 19.45 26.0375C20.8 26.7875 22.35 27.1875 23.9 27.1875H24.1C25.65 27.1875 27.15 26.7875 28.55 26.0375C31.5 24.3375 33.35 21.1875 33.35 17.7875V17.2875L35.7 16.4375V20.7375H35.55C35 20.7375 34.6 21.1875 34.6 21.6875V24.5375C34.6 24.7875 34.8 25.0375 35.1 25.0375H37.3C37.55 25.0375 37.8 24.8375 37.8 24.5375V21.6875C37.8 21.1375 37.35 20.7375 36.85 20.7375H36.7V16.0875L39.7 15.0375C39.9 14.9875 40 14.7875 40 14.5875C40 14.3375 39.85 14.1875 39.7 14.0875Z",
    fill: "#3077F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1502 25.3506C30.5002 25.9506 29.8002 26.5006 29.0002 26.9506C27.4502 27.8006 25.8002 28.2506 24.1002 28.2506H23.9002C22.2002 28.2506 20.5002 27.8006 19.0002 26.9506C18.2002 26.5006 17.5002 25.9506 16.8502 25.3506C13.0502 26.1006 10.2002 29.4506 10.2002 33.4506V39.0006C10.2002 39.2506 10.4002 39.5006 10.7002 39.5006H37.3002C37.5502 39.5006 37.8002 39.3006 37.8002 39.0006V33.4006C37.8002 29.4006 34.9002 26.1006 31.1502 25.3506Z",
    fill: "#3077F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12262_73053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/schoolIcon.c0673920439229c377a52c6b83e450fa.svg";
export { ForwardRef as ReactComponent };